<template>
    <div>
        <date-range-picker id="range" ref="picker" v-model="date" opens="right" :locale-data="localeDate"
            :show-week-numbers="false" :show-dropdowns="true" :auto-apply="false" :ranges="dateRanges">
            <template v-if="date.startDate && date.endDate" v-slot:input="picker">
                {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </template>
            <template v-else v-slot:input> Período </template>
        </date-range-picker>

    </div>

</template>

<script>
import { date } from '@/src/filters/date';
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import { mapGetters } from 'vuex'


export default {
    components: {
        DateRangePicker,
    },
    data() {
        return {
            date: {
                startDate: null,
                endDate: null,
            },
            localeDate: {
                direction: 'ltr',
                format: 'mm/dd/yyyy',
                separator: ' - ',
                applyLabel: 'Aplicar',
                cancelLabel: 'Cancelar',
                weekLabel: 'W',
                customRangeLabel: 'Custom Range',
                daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                monthNames: [
                    'Jan',
                    'Fev',
                    'Mar',
                    'Abr',
                    'Mai',
                    'Jun',
                    'Jul',
                    'Ago',
                    'Set',
                    'Out',
                    'Nov',
                    'Dez',
                ],
                firstDay: 0,
            },
        }
    },
    watch: {
        date(value) {
            this.$store.dispatch('updateFilterDate', {
                startDate: moment(value.startDate).format('YYYY-MM-DD'),
                endDate: moment(value.endDate).format('YYYY-MM-DD')
            })

            if (this.getTypeFilterDate) {
                this.$store.dispatch('updateChargebacksCurrentPage', 1) 
                this.$store.dispatch('fetchChargebacks')
                this.$store.dispatch('updateNoFilters', false)
            }
        },
        getNoFilters: {
            handler(newValue) {
                if (newValue) {
                    this.resetDate();
                }
            },
        },
    },
    methods: {
        resetDate() {
            // Manually updating each property to ensure reactivity
            this.date = {
                startDate: null,
                endDate: null,
            };
            this.$store.dispatch('updateNoFilters', false)
        }
    },
    computed: {
        ...mapGetters(['getNoFilters','getTypeFilterDate']),
        dateRanges() {
            let today = new Date()
            today.setHours(0, 0, 0, 0)

            let yesterday = new Date()
            yesterday.setDate(today.getDate() - 1)
            yesterday.setHours(0, 0, 0, 0)

            let lastWeek = new Date()
            lastWeek.setDate(today.getDate() - 7)
            lastWeek.setHours(0, 0, 0, 0)

            return {
                Hoje: [today, today],
                Ontem: [yesterday, yesterday],
                'Última semana': [lastWeek, today],
                'Este mês': [
                    new Date(today.getFullYear(), today.getMonth(), 1),
                    new Date(today.getFullYear(), today.getMonth(), 30),
                ],
                'Este ano': [
                    new Date(today.getFullYear(), 0, 1),
                    new Date(today.getFullYear(), 11, 31),
                ],
                'Último mês': [
                    new Date(today.getFullYear(), today.getMonth() - 1, 1),
                    new Date(today.getFullYear(), today.getMonth(), 0),
                ],
            }
        },
    },

}
</script>

<style lang="scss" scoped></style>